import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon';

export const ExclamationIcon: ComponentWithAs<'svg', IIconProps> = (
  props: any,
) => (
  <Icon data-testid="exclamation-icon" {...props}>
    <rect width="16" height="16" rx="8" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.77841 8.10333C8.73674 8.43145 8.68182 8.76592 8.61364 9.10673H7.42045C7.35227 8.76592 7.29735 8.43145 7.25568 8.10333C7.21402 7.77521 7.19318 7.44437 7.19318 7.11081V4H8.84091V7.11081C8.84091 7.44437 8.82008 7.77521 8.77841 8.10333ZM8.39205 11.9293C8.27083 11.9764 8.14015 12 8 12C7.85606 12 7.72348 11.9764 7.60227 11.9293C7.48106 11.8822 7.37595 11.8169 7.28693 11.7335C7.19792 11.6501 7.12784 11.5513 7.0767 11.4371C7.02557 11.3229 7 11.2005 7 11.07C7 10.9395 7.02557 10.818 7.0767 10.7056C7.12784 10.5932 7.19792 10.4954 7.28693 10.412C7.37595 10.3286 7.48106 10.2624 7.60227 10.2135C7.72348 10.1645 7.85606 10.14 8 10.14C8.14015 10.14 8.27083 10.1645 8.39205 10.2135C8.51326 10.2624 8.61932 10.3286 8.71023 10.412C8.80114 10.4954 8.87216 10.5932 8.9233 10.7056C8.97443 10.818 9 10.9395 9 11.07C9 11.2005 8.97443 11.3229 8.9233 11.4371C8.87216 11.5513 8.80114 11.6501 8.71023 11.7335C8.61932 11.8169 8.51326 11.8822 8.39205 11.9293Z"
      fill="white"
    />
  </Icon>
);
